import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './index.css';

// Pages
import Login from './pages/Login';
import Layout from './components/Layout';

import AdminDashboard  from './pages/admin/Dashboard';
import AdminCustomers  from './pages/admin/Customers';
import AdminDevices    from './pages/admin/Devices';
import AdminUsers      from './pages/admin/Users';

import CustomerDashboard from './pages/customer/Dashboard';
import CustomerReports   from './pages/customer/Reports';
import CustomerDevices   from './pages/customer/Devices';
import CustomerAlarms    from './pages/customer/Alarms';

// ─── Route guard: giriş yapılmamışsa login'e ─────────────────────────────────
function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

// ─── Sadece super_admin ───────────────────────────────────────────────────────
function RequireAdmin({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role !== 'super_admin') return <Navigate to="/dashboard" replace />;
  return children;
}

// ─── Sadece customer rol'leri ─────────────────────────────────────────────────
function RequireCustomer({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role === 'super_admin') return <Navigate to="/admin" replace />;
  return children;
}

// ─── Kök yönlendirme ─────────────────────────────────────────────────────────
function Root() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'super_admin') return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/"      element={<Root />} />

          {/* Admin routes */}
          <Route path="/admin" element={
            <RequireAdmin><Layout><AdminDashboard /></Layout></RequireAdmin>
          } />
          <Route path="/admin/customers" element={
            <RequireAdmin><Layout><AdminCustomers /></Layout></RequireAdmin>
          } />
          <Route path="/admin/devices" element={
            <RequireAdmin><Layout><AdminDevices /></Layout></RequireAdmin>
          } />
          <Route path="/admin/users" element={
            <RequireAdmin><Layout><AdminUsers /></Layout></RequireAdmin>
          } />

          {/* Customer routes */}
          <Route path="/dashboard" element={
            <RequireCustomer><Layout><CustomerDashboard /></Layout></RequireCustomer>
          } />
          <Route path="/dashboard/reports" element={
            <RequireCustomer><Layout><CustomerReports /></Layout></RequireCustomer>
          } />
          <Route path="/dashboard/devices" element={
            <RequireCustomer><Layout><CustomerDevices /></Layout></RequireCustomer>
          } />
          <Route path="/dashboard/alarms" element={
            <RequireCustomer><Layout><CustomerAlarms /></Layout></RequireCustomer>
          } />

          {/* 404 → ana sayfa */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
